import React from "react";
import BusinessCreationModal from "./BusinessCreationModal";
import CriminalRecordModal from "./CriminalRecordModal";
import CertificateNationalityModal from "./CertificateNationalityModal";
import CertificateSinglenessModal from "./CertificateSinglenessModal";
import EneoModal from "./EneoModal";
import CustomsRebateModal from "./CustomsRebateModal";
import BusinessPlanModal from "./BusinessPlanModal";
import ImportationModal from "./ImportationModal";
import OapiModal from "./OapiModal";
import PassportModal from "./PassportModal";
import VisualIdentityModal from "./VisualIdentityModal";

// Detail window of each request type
export const REQUEST_MODALS = {
  CriminalRecordRequest: CriminalRecordModal,
  NationalityCertificateRequest: CertificateNationalityModal,
  CelibacyCertificateRequest: CertificateSinglenessModal,
  PassportEnrollmentRequest: PassportModal,
  EneoRequest: EneoModal,
  CustomsRebateRequest: CustomsRebateModal,
  BusinessPlanRequest: BusinessPlanModal,
  ImportationRequest: ImportationModal,
  OapiRequest: OapiModal,
  VisualIdentityRequest: VisualIdentityModal,
  TrademarkRequest: VisualIdentityModal,
  TaxRegistrationRequest: VisualIdentityModal,
  TaxComplianceRequest: VisualIdentityModal,
  CnpsRegistrationRequest: VisualIdentityModal,
};

// Opens the detail window matching the request type
function RequestDetail({ request, onHide }) {
  if (!request) return null;

  if (request.type === "RegistrationRequest") {
    return (
      <BusinessCreationModal show onHide={onHide} businessCreation={request} />
    );
  }

  const Modal = REQUEST_MODALS[request.type];
  return Modal ? <Modal show onHide={onHide} procedure={request} /> : null;
}

export default RequestDetail;
